import { TauriDiscoverError } from '@ui/Utils/scan/handleDiscoverTauri';

import { ScanStrategy } from '../types';
import { rtcStrategy } from './rtcStrategy';
import { tauriStrategy } from './tauriStrategy';

export const hybridStrategy: ScanStrategy = {
    kind: 'hybrid',
    async start(signal, opts, onProgress) {
        console.log('[HybridStrategy] Starting device discovery with options:', opts);

        // First, try Tauri strategy
        try {
            console.log('[HybridStrategy] Attempting Tauri native discovery...');
            onProgress({ progress: 5, title: 'Trying native device discovery...' });
            const result = await tauriStrategy.start(signal, opts, onProgress);
            console.log('[HybridStrategy] Tauri discovery successful:', result);
            return result;
        } catch (error) {
            console.log('[HybridStrategy] Tauri discovery failed:', error);

            // If Tauri fails, check if it's because Tauri is not available
            if (error instanceof TauriDiscoverError || (error instanceof Error && error.message.includes('Tauri'))) {
                console.log('[HybridStrategy] Tauri discovery failed, falling back to RTC:', error.message);

                // Check if we have instanceId for RTC fallback
                if (!opts.instanceId) {
                    console.error('[HybridStrategy] Cannot fallback to RTC: no instance ID provided');
                    throw new Error('Native discovery failed and no instance selected for fallback');
                }

                if (!opts.instance) {
                    console.error('[HybridStrategy] Cannot fallback to RTC: no instance object provided');
                    throw new Error('Native discovery failed and instance object not available for fallback');
                }

                // Fallback to RTC strategy
                console.log('[HybridStrategy] Starting RTC fallback with instanceId:', opts.instanceId);
                onProgress({ progress: 10, title: 'Falling back to network discovery...' });
                const result = await rtcStrategy.start(signal, opts, onProgress);
                console.log('[HybridStrategy] RTC discovery successful:', result);
                return result;
            }

            // If it's not a Tauri availability error, re-throw the original error
            console.error('[HybridStrategy] Non-Tauri error, re-throwing:', error);
            throw error;
        }
    },
};
